module.exports = __webpack_public_path__ + "img/TensorFlow.409db54.svg";